export const FETCH_BUSINESS_UNIT_DELAY = 300;

export const DROPDOWN_ITEMS_PER_PAGE = 20;

export const CALENDAR_DATE_FORMAT = 'yyyy-MM-dd';
/**
 * General app date format for date-fns
 */
export const GENERAL_DATE_FORMAT = 'MMM d, yyyy';

export const SEARCH_INPUT_MAX_CHAR = 320;

export const COMPANY_NAME_MAX_LENGTH = 50;

export const FREE_TEXT_FIELD_TITLE_MAX_LENGTH = 100;
